<template>
  <v-container class="d-flex justify-center align-center">
    <amplify-authenticator></amplify-authenticator>
  </v-container>
</template>
<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { Auth } from "aws-amplify";


export default {
  name: "Login",
  data() {
    return {
      configurationOptions: {
        signInConfig: {
          isSignUpDisplayed: false,
        },
      },
    };
  },

  async mounted() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        this.$router.push("test-list");
      }
    } catch {
      AmplifyEventBus.$on("authState", (state) => {
        if (state === "signedIn") {
          this.$router.push("test-list");
        }
      });
    }
  },
};
</script>
